import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { tokenInterceptor } from './auth/token.interceptor';
import { provideFirebaseApp, provideFirebaseAuth } from './firebase';

export const appConfig: ApplicationConfig = {
  providers: [
    provideFirebaseApp(),
    provideFirebaseAuth(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimations(),
    provideHttpClient(withInterceptors([tokenInterceptor])),
  ],
};
